<div id="loader">
    <app-loader></app-loader>
</div>
<router-outlet></router-outlet>